import { memo } from "react";

const Loading = () => {
	return (
		<div
			style={{
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
				justifyContent: "center",
				height: "100%",
				width: "100%",
			}}
		>
			<div
				style={{
					width: "40px",
					height: "40px",
					border: "4px solid #f3f3f3",
					borderTop: "4px solid #3498db",
					borderRadius: "50%",
					animation: "spin 1s linear infinite",
				}}
			/>
			<p
				style={{
					marginTop: "16px",
					fontSize: "16px",
					color: "#666",
				}}
			>
				Loading...
			</p>

			<style>{`
       @keyframes spin {
         0% { transform: rotate(0deg); }
         100% { transform: rotate(360deg); }
       }
     `}</style>
		</div>
	);
};

export default memo(Loading);
